export const normalizeBusinessType = (value) => {
  if (value === "boutique") return "boutique";
  return "restaurant";
};

export const extractBusinessType = (info) =>
  normalizeBusinessType(info?.business_type || info?.businessType);

export const getStoredBusinessType = () => {
  if (typeof window === "undefined") return "restaurant";
  try {
    const cached = localStorage.getItem("restaurant-info");
    if (cached) {
      const parsed = JSON.parse(cached);
      return extractBusinessType(parsed);
    }
  } catch (_e) {
    // ignore parsing errors
  }
  return "restaurant";
};
